// Mock fallback data (public-domain scripture). Used only if the backend is unreachable.
export const mockVerse = {
  ref: "Philippians 4:13",
  bookId: "PHP",
  book: "Philippians",
  chapter: 4,
  verse: 13,
  text: "I can do all things through Christ who gives me strength.",
};

export const mockCanon = {
  language: "en",
  translations: ["BSB"],
  bookCount: 93,
  books: [
    { id: "GEN", name: "Genesis", order: 1, testament: "OT", canonGroup: "protocanon", numberOfChapters: 50 },
    { id: "EXO", name: "Exodus", order: 2, testament: "OT", canonGroup: "protocanon", numberOfChapters: 40 },
    { id: "PSA", name: "Psalms", order: 19, testament: "OT", canonGroup: "protocanon", numberOfChapters: 150 },
    { id: "PRO", name: "Proverbs", order: 20, testament: "OT", canonGroup: "protocanon", numberOfChapters: 31 },
    { id: "MAT", name: "Matthew", order: 40, testament: "NT", canonGroup: "protocanon", numberOfChapters: 28 },
    { id: "JHN", name: "John", order: 43, testament: "NT", canonGroup: "protocanon", numberOfChapters: 21 },
    { id: "ROM", name: "Romans", order: 45, testament: "NT", canonGroup: "protocanon", numberOfChapters: 16 },
    { id: "PHP", name: "Philippians", order: 50, testament: "NT", canonGroup: "protocanon", numberOfChapters: 4 },
    { id: "ENO", name: "1 Enoch", order: 87, testament: "OT", canonGroup: "ethiopian", numberOfChapters: 108 },
    { id: "JUB", name: "Jubilees", order: 88, testament: "OT", canonGroup: "ethiopian", numberOfChapters: 50 },
  ],
};

export function mockChapter(bookId, chapter) {
  const names = { GEN: "Genesis", JHN: "John", PSA: "Psalms", PHP: "Philippians" };
  return {
    book: { id: bookId, name: names[bookId] || bookId },
    translation: { id: "BSB", name: "Berean Standard Bible", license: "Public Domain", source: "helloao" },
    number: Number(chapter) || 1,
    verses: [
      { number: 1, text: "In the beginning God created the heavens and the earth." },
      { number: 2, text: "Now the earth was formless and void, and darkness was over the surface of the deep. And the Spirit of God was hovering over the surface of the waters." },
      { number: 3, text: "And God said, \u201cLet there be light,\u201d and there was light." },
      { number: 4, text: "And God saw that the light was good, and He separated the light from the darkness." },
    ],
  };
}

export function mockChatReply() {
  return "# Peace be with you\n\nI'm here to walk with you through Scripture. The backend guide is not connected in this preview, but here is a word to encourage you:\n\n> \u201cThe LORD is my shepherd; I shall not want.\u201d \u2014 *Psalm 23:1*\n\nAsk me about any **verse**, **person**, or **theme**, and I'll point you to God's Word.";
}
